/**
 * Created by rickborst on 13/06/2017.
 */

import {ActionTypes} from 'store/actions/widgets/navigation';

const defaultState = {
    topNavigation: {
        items: []
    },
    collectionPagesAmount: 0,
    toTopDistance: 0
};

/**
 * Returns the top navigation state.
 *
 * @param {Object} state - The current state.
 * @param {Object} action - Action.
 * @returns {Object} New state.
 */
function setTopNavigation (state, action) {

    return {
        ...state,
        topNavigation: {
            items: [
                ...action.items
            ]
        }
    };
}

/**
 * Returns the navigation state.
 *
 * @param {Object} state - The current state.
 * @param {Object} action - The current action.
 * @returns {Object} Current state.
 */
function navigation (state = defaultState, action) {

    switch (action.type) {

        case ActionTypes.SET_TOP_NAVIGATION:
            return setTopNavigation(state, action);

        case ActionTypes.SET_TOP_DISTANCE:
            return {
                ...state,
                toTopDistance: action.toTopDistance
            };

        case ActionTypes.SET_FROM_BACK:
            return {
                ...state,
                isFromBack: action.isFromBack
            };

        case ActionTypes.SET_COLLECTION_PAGES_AMOUNT:
            return {
                ...state,
                collectionPagesAmount: action.collectionPagesAmount
            };

        default:
            return state;
    }
}

export default navigation;


// WEBPACK FOOTER //
// ./src/js/store/reducers/widgets/navigation.js